import Vue from 'vue';
import recipeTransformer from '../../transformers/recipe';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeTransformer.fetch(errors));
};

export default (id, recipe) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/recipe/${id}`, recipe)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/update.js